import { FC } from 'react';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmButtonClass?: string;
}

const ConfirmModal: FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Подтверждение',
  message,
  confirmLabel = 'OK',
  cancelLabel = 'Отмена',
  confirmButtonClass = 'bg-indigo-600 hover:bg-indigo-700',
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50 transition-opacity animate-fadeIn">
      <div className="bg-white dark:bg-zinc-900 rounded-xl shadow-lg w-full max-w-md p-6 border border-gray-100 dark:border-zinc-800 transform transition-all scale-100 hover:scale-[1.02] duration-150 ease-out">
        {title && (
          <h2 className="text-xl font-bold text-gray-900 dark:text-zinc-100 mb-3 border-b dark:border-zinc-800 pb-2">{title}</h2>
        )}
        <p className="text-gray-700 dark:text-zinc-200 mb-6 leading-relaxed whitespace-pre-line">
          {message}
        </p>
        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="bg-gray-200 dark:bg-zinc-700 hover:bg-gray-300 dark:hover:bg-zinc-600 text-gray-800 dark:text-zinc-200 font-medium py-2 px-6 rounded-lg shadow-sm transition-transform transform hover:scale-105"
          >
            {cancelLabel}
          </button>
          <button
            onClick={handleConfirm}
            className={`${confirmButtonClass} text-white font-medium py-2 px-6 rounded-lg shadow-sm transition-transform transform hover:scale-105`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;

